import { MarketType, User, ZERO } from '@drift-labs/sdk';
import { ENUM_UTILS, UISerializableOrder } from '@drift/common';
import { LeftoverIsolatedPositionsResult } from './types';

export function findStrandedIsolatedMargin(
	user: User,
	openOrders: UISerializableOrder[]
): LeftoverIsolatedPositionsResult {
	const ua = user.getUserAccount();

	return ua.perpPositions
		.filter((pos) => pos.baseAssetAmount.abs().eq(ZERO))
		.filter(
			(pos) =>
				user.isPerpPositionIsolated(pos) &&
				pos.isolatedPositionScaledBalance.gt(ZERO)
		)
		.filter((pos) => {
			if (pos.openOrders !== 0) return false;
			const hasUiOpenOrder = openOrders.some(
				(o) =>
					ENUM_UTILS.match(o.marketType, MarketType.PERP) &&
					o.marketIndex === pos.marketIndex
			);
			return !hasUiOpenOrder;
		})
		.map((pos) => ({
			marketIndex: pos.marketIndex,
			isolatedPositionScaledBalance: pos.isolatedPositionScaledBalance,
		}));
}
